import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/apiAuth";
import { toast } from "react-toastify";
/* import api from "../../utils/api"; */

export const uploadProfileImage = createAsyncThunk(
  "img/uploadProfileImage",
  async ({ file, userId }, { rejectWithValue }) => {
    try {
      if (!userId) {
        throw new Error("Kullanıcı ID'si bulunamadı!");
      }
      const formData = new FormData();
      formData.append("relatedId", userId);
      formData.append("relatedType", "User");
      formData.append("imageType", "Profile");
      formData.append("file", file);

      const response = await api.post("/images/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (!response.data || !response.data.success) {
        throw new Error(response.data?.message || "Sunucudan yanıt alınamadı");
      }

      toast.success(response.data.message);

      // Yeni profil fotoğrafını hemen getir
      const imageResponse = await api.get(`/images/${userId}`);
      return imageResponse.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Fotoğraf yüklenemedi!";
      toast.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

export const getProfileImage = createAsyncThunk(
  "img/getProfileImage",
  async (userId, { rejectWithValue }) => {
    try {
      if (!userId) {
        throw new Error("Kullanıcı ID'si bulunamadı!");
      }

      const response = await api.get(`/images/${userId}`);

      if (!response.data || !response.data.success) {
        throw new Error(response.data?.message || "Resim yüklenemedi");
      }

      const returnData = {
        userId,
        data: response.data.data,
      };
      return returnData;
    } catch (error) {
      const errorDetails = {
        message: error.response?.data?.message || error.message,
        status: error.response?.status,
        data: error.response?.data || error,
      };
      return rejectWithValue(errorDetails.message);
    }
  }
);

export const deleteProfileImage = createAsyncThunk(
  "img/deleteProfileImage",
  async (imageId, { rejectWithValue }) => {
    try {
      if (!imageId) {
        throw new Error("Resim ID'si bulunamadı!");
      }

      const response = await api.delete(`/images/${imageId}`);

      if (response.status === 200 || response.status === 204) {
        toast.success("Profil fotoğrafı başarıyla silindi");
        return { success: true, imageId };
      }

      throw new Error("Resim silinemedi");
    } catch (error) {
      if (error.response?.status === 404) {
        toast.success("Profil fotoğrafı kaldırıldı");
        return { success: true, imageId };
      }

      const errorMessage =
        error.response?.data?.message || "Resim silinirken bir hata oluştu";
      toast.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);
